import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { endpoints } from '../../utils/endpoints';
import { TournamentMatchesTabItem } from '../models/api/requests/tournamentMatches.request';
import { PlayerNotificationsResponse } from '../../profile/models/currentPlayer.interface';

@Injectable({
    providedIn: 'root',
})
export class TournamentMatchesService {
    private http = inject(HttpClient);


    fetchTournamentMatches(tournamentId: string, page: number, pageSize: number)  {
            let query = new HttpParams();
            query = query.append('page', page);
            query = query.append('pageSize', pageSize);
        return this.http
            .get<TournamentMatchesTabItem[]>(
                endpoints.tournaments.children.getTournamentTabMatches(
                    tournamentId
                ),
                {
                    params: query,
                }
            )
            .pipe(shareReplay());
    }
    fetchTournamentV2Matches(tournamentId: string, page: number, pageSize: number)  {
            let query = new HttpParams();
            query = query.append('page', page);
            query = query.append('pageSize', pageSize);
        return this.http
            .get<TournamentMatchesTabItem[]>(
                endpoints.tournaments.children.getV2TournamentTabMatches(
                    tournamentId
                ),
                {
                    params: query,
                }
            )
            .pipe(shareReplay());
    }
    fetchTournamentPlayerMatches(tournamentId: string, playerId: string) {
        return this.http
            .get<TournamentMatchesTabItem[]>(
                endpoints.tournaments.children.getTournamentPlayerMatches(
                    tournamentId,
                    playerId
                )
            )
            .pipe(shareReplay());
    }
    fetchTournamentPlayerV2Matches(tournamentId: string, playerId: string) {
        return this.http
            .get<TournamentMatchesTabItem[]>(
                endpoints.tournaments.children.getTournamentPlayerMatchesV2(
                    tournamentId,
                    playerId
                )
            )
            .pipe(shareReplay());
    }
}
